import { UnidadeImportacao } from "core/features/unidades/typings/unidade";
import { showError, showErrorAxios } from "infra/helpers/alerta";
import excelToJson from "infra/helpers/excelToJson";
import { useState } from "react";
import { logError } from "infra/packages/@sentry/logError";

import { columns as defaultColumns } from "../columns";

type ErrorType = {
  successIndexes: number[];
  message: string;
  errors: { field: string; message: string[]; index: number }[];
};

export function useImportacaoUnidade() {
  const [data, setData] = useState<UnidadeImportacao[]>([]);

  function onRowDelete(
    e: React.MouseEvent<HTMLDivElement>,
    { rowIdx }: { rowIdx: number }
  ) {
    setData([...data.slice(0, rowIdx), ...data.slice(rowIdx + 1)]);
  }

  function onRowInsertAbove(
    e: React.MouseEvent<HTMLDivElement>,
    { rowIdx }: { rowIdx: number }
  ) {
    insertRow(rowIdx);
  }

  function onRowInsertBelow(
    e: React.MouseEvent<HTMLDivElement>,
    { rowIdx }: { rowIdx: number }
  ) {
    insertRow(rowIdx + 1);
  }

  function insertRow(insertRowIdx: number) {
    const newRow: UnidadeImportacao = {} as UnidadeImportacao;

    setData([
      ...data.slice(0, insertRowIdx),
      newRow,
      ...data.slice(insertRowIdx),
    ]);
  }

  const handleProccess = async (file: any) => {
    try {
      const rows = await excelToJson<
        UnidadeImportacao & { index: any },
        keyof UnidadeImportacao
      >(file);

      if (rows.length) {
        const columns = Object.keys(rows[0]);

        for (const column of columns) {
          if (!defaultColumns.find((col) => col.key === column)) {
            showError(
              "A coluna " +
                column +
                " não é válida. O nome das colunas deve ser exatamente como no exemplo!"
            );
            return;
          }
        }
      }

      setData(rows);
    } catch (err) {
      console.log("err", err);
      showError("Planilha em formato incorreto!");
    }
  };

  const handleProccessError = async (err: any) => {
    if (err.response?.status === 400) {
      const newData = data.map((item, index) => {
        const exists = (
          err.response?.data?.message.filter((_item: string) =>
            _item.includes(`items.${index}.`)
          ) ?? []
        ).map((message: string) => message.replace(/(items).[0-9]*./, ""));

        if (!exists.length) {
          return { ...item, errors: {} };
        }

        return {
          ...item,
          errors: {
            unidade: [exists],
          },
        };
      });

      setData(newData);

      showError(err.message);
    } else if (err.response?.status === 422) {
      let _err = err.response.data as ErrorType;

      logError(err);

      const newData = data
        .map((item, index) => {
          const errors: any = _err.errors
            .filter((err) => err.index === index)
            .reduce((acc, next) => {
              if (acc[next.field]) {
                acc[next.field] = acc[next.field].concat(next.message);
              } else {
                acc[next.field] = next.message;
              }
              return acc;
            }, {} as Record<string, string[]>);

          return {
            ...item,
            errors,
          };
        })
        .filter((_item) => Object.keys(_item.errors).length);

      setData([...newData]);

      showError(_err.message);
    } else {
      showErrorAxios(err);
    }
  };

  return {
    handleProccessError,
    onRowInsertBelow,
    onRowInsertAbove,

    handleProccess,
    onRowDelete,

    setData,
    data,
  };
}
